import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Box, CircularProgress } from '@mui/material'

import { RootState } from './app/store'

// Import pages
import LoginPage from './pages/LoginPage'
import ModernDashboardPage from './pages/ModernDashboardPage'
import ModernCourseCatalogPage from './pages/ModernCourseCatalogPage'
import ModernAssessmentCatalogPage from './pages/ModernAssessmentCatalogPage'
import CourseViewPage from './pages/CourseViewPage'
import AssessmentPage from './pages/AssessmentPage'
import DebugAssignments from './pages/DebugAssignments'
import ProfilePage from './pages/ProfilePage'
import AdminDashboardPage from './pages/admin/AdminDashboardPage'
import UserManagementPage from './pages/admin/UserManagementPage'
import CourseManagementPage from './pages/admin/CourseManagementPage'
import AssessmentManagementPage from './pages/admin/AssessmentManagementPage'
import ReportsPage from './pages/admin/ReportsPage'

// Import components
import ProtectedRoute from './components/ProtectedRoute'
import ModernLayout from './components/ModernLayout'

function App() {
  const { isAuthenticated, isLoading, token } = useSelector((state: RootState) => state.auth)

  if (isLoading && token) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    )
  }

  if (isLoading && token) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route 
        path="/login" 
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />
        } 
      />
      
      {/* Protected routes */}
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <ModernLayout />
          </ProtectedRoute>
        }
      >
        {/* Learner routes */}
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<ModernDashboardPage />} />
        <Route path="debug-assignments" element={<DebugAssignments />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="courses" element={<ModernCourseCatalogPage />} />
        <Route path="courses/:courseId" element={<CourseViewPage />} />
        <Route path="assessments" element={<ModernAssessmentCatalogPage />} />
        <Route path="assessments/:assessmentId" element={<AssessmentPage />} />
        
        {/* Admin routes */}
        <Route 
          path="admin" 
          element={
            <ProtectedRoute requiredPermissions={['courses.add_course', 'courses.change_course', 'assessments.add_assessment', 'assessments.change_assessment']}>
              <AdminDashboardPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="admin/users" 
          element={
            <ProtectedRoute requiredPermissions={['users.add_user', 'users.change_user']}>
              <UserManagementPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="admin/courses" 
          element={
            <ProtectedRoute requiredPermissions={['courses.add_course', 'courses.change_course']}>
              <CourseManagementPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="admin/assessments" 
          element={
            <ProtectedRoute requiredPermissions={['assessments.add_assessment', 'assessments.change_assessment']}>
              <AssessmentManagementPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="admin/reports" 
          element={
            <ProtectedRoute requiredPermissions={['courses.view_course', 'assessments.view_assessment']}>
              <ReportsPage />
            </ProtectedRoute>
          } 
        />
      </Route>
      
      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
